import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  LOGIN_REQUEST,
  VERIFICATION_FAIL,
  VERIFICATION_SUCCESS,
  VERIFICATION_REQUEST,
} from "../constants/userConstants";

import {
  BIOMETRIC_CHECK_REQUEST,
  BIOMETRIC_AVAILABLE,
  BIOMETRIC_NOT_AVAILABLE,
  BIOMETRIC_LOGIN_REQUEST,
  BIOMETRIC_LOGIN_SUCCESS,
  BIOMETRIC_LOGIN_FAIL,
} from "../constants/biometricConstants";

const initialState = {
  isLoggedIn: false,
  user: null,
  error: null,
  number: null,
  loading: false,
  data: null,
  msg: null,
  token: null,
  biometricAvailable: false,
  biometricLoading: false,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case VERIFICATION_REQUEST:
      return {
        ...state,
        loading: false,
        number: action.payload.number,
        msg: action.payload.msg,
        useData: action.payload.useData,
        token: action.payload.token,
        encryptedOTP: action.payload.encryptedOTP,
        plainOTP: action.payload.plainOTP,
      };
    case VERIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        number: action.payload.number,
        msg: null,
        user: action.payload.user,
        token: action.payload.Token || action.payload.token || state.token,
      };
    case VERIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        msg: action.payload.msg,
        token: null,
        user: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        msg: null,
        loading: false,
        data: action.payload.data,
        number: null,
        token: action.payload.token || action.payload.Token || state.token,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        msg: action.payload.msg,
        loading: false,
        number: null,
        token: null,
        user: null,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        error: null,
        number: null,
        loading: false,
        data: null,
        msg: null,
        token: null,
      };
    case BIOMETRIC_CHECK_REQUEST:
      return {
        ...state,
        biometricLoading: true,
      };
    case BIOMETRIC_AVAILABLE:
      return {
        ...state,
        biometricAvailable: true,
        biometricLoading: false,
      };
    case BIOMETRIC_NOT_AVAILABLE:
      return {
        ...state,
        biometricAvailable: false,
        biometricLoading: false,
      };
    case BIOMETRIC_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        biometricLoading: true,
      };
    case BIOMETRIC_LOGIN_SUCCESS:
      return {
        ...state,
        biometricLoading: false,
      };
    case BIOMETRIC_LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        biometricLoading: false,
        msg: action.payload.msg,
      };
    default:
      return state;
  }
};
